import { EVerticalNames } from '@constants';
import { Form } from 'antd';

import { StepWrapper } from '../../../styles';
import { ExamGroupsWarning } from '../../ExamGroupsWarning';
import { TranslatedTitle, TranslatedText } from '../components';

import { AutonomousCommunitySelector } from '@/components/Form';
import { ExamGroupSelector } from '@/components/Form/ExamGroupSelector/';
import { ExamGroupSelectorPCE } from '@/components/Form/ExamGroupSelectorPCE';
import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useOnboardingFormLogic } from '@/hooks';

export const PrepareForChallenge = () => {
  const {
    userInfo: { isUserFromPCE },
    setExamGroupDate
  } = useOnboardingFormLogic();
  const objName = isUserFromPCE ? 'pceUserInfo' : 'uniUserInfo';
  return (
    <StepWrapper>
      <TranslatedTitle i18nKey="PREPARE_FOR_THE_CHALLENGE" />
      <Box flexDirection="column" gap={24}>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="AUTONOMOUS_COMMUNITY" />
          <Form.Item rules={[RULES.REQUIRED]} name={['userInfo', objName, 'autonomousCommunity']}>
            <AutonomousCommunitySelector variant="outlined" />
          </Form.Item>
        </Box>
        <Box flexDirection="column" gap={12}>
          <TranslatedText i18nKey="EXAM_GROUP" />
          <Form.Item name={['userInfo', 'examGroups']} style={{ marginBottom: 0 }}>
            {isUserFromPCE ? (
              <ExamGroupSelectorPCE mode="multiple" onExamGroupSelect={setExamGroupDate} />
            ) : (
              <ExamGroupSelector
                mode="multiple"
                vertical={EVerticalNames.UNI}
                onExamGroupSelect={setExamGroupDate}
              />
            )}
          </Form.Item>
          <ExamGroupsWarning />
        </Box>
      </Box>
    </StepWrapper>
  );
};
